import React, { useState, useEffect } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Form,
  FormFeedback,
  Table,
  CardHeader,
} from "reactstrap";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Loader } from "../Utils/Loader";
import { LabelText } from "../Utils/Input";
import {
  isEmptyOrInvalidField,
  handleChangeForAttributeValue,
  deviceJsonObj,
} from "./constants/constantFunctions";
import { addDevice } from "../../slices/Device/Adddevice/thunk";
import { getIdDevice } from "../../slices/Device/FetchDevice/thunk";
import { useLocation } from "react-router-dom";
import { updateDevice } from "../../slices/Device/EditDevice/thunk";
import { DeviceType, StatusType, validationSchema } from "./constants/constant";
import Attribute from "./Attribute";
import { DeviceForm } from "./DeviceForm";
import CommonButton from ".././Utils/CommonButton"
import { PAGE_TITLES } from "../Common/constants";
import ViewDevice from "./ViewDevice";

export default function createDevice() {
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [enableFormReinitialize, setEnableFormReinitialize] = useState(false);
  const [deviceID, setDeviceID] = useState([]);
  const isEdit = location.pathname.includes("update-device");
  const isView = location.pathname.includes("view-device");
  const isCreate = location.pathname.includes("create-device");
  const [title, setTitle] = useState("");
  let attributesLength = 0;

  const deviceIdPath = location.pathname.slice(
    location.pathname.lastIndexOf("/"),
    location.pathname.length
  );

  const deviceId = deviceIdPath.slice(1, deviceIdPath.length);

  const initialValues = {
    deviceId: "",
    deviceType: "",
    status: "",
    attributeList: [],
  };

  let initialFormValues = initialValues;

  useEffect(() => {
    if (isEdit) {
      setTitle(PAGE_TITLES.EDIT_DEVICE);
    } else if (isView) {
      setTitle(PAGE_TITLES.VIEW_DEVICE);
    } else {
      setTitle(PAGE_TITLES.ADD_DEVICE);
    }
  }, [isEdit]);

  useEffect(() => {
    if (isCreate) {
      setEnableFormReinitialize(true);
    }
  }, [isCreate]);

  useEffect(() => {
    if (isEdit || isView) {
      dispatch(
        getIdDevice(deviceId, isEdit || isView, initialValues, setLoading, setDeviceID)
      );
    }
  }, [dispatch, isEdit]);

  const fetchDeviceData = useSelector((state) => state.fetchDevice.fetchDevice)

  if (isEdit) {
    if ("attributeList" in fetchDeviceData) {
      attributesLength = fetchDeviceData?.attributeList?.length;
    }
  }
  const registerOrEditDevice = async (jsonObj) => {
    if (isEdit) {
      dispatch(updateDevice(jsonObj, setLoading, navigate, deviceId));
    } else {
      dispatch(addDevice(jsonObj, setLoading, navigate));
    }
  };
  const onSubmit = (values) => {
    let jsonObj;
    if (isEdit) {
      const newAttributes = values?.attributeList?.filter(
        (_, index) => index >= attributesLength
      );
      jsonObj = deviceJsonObj(values, isEdit, newAttributes);
    } else {
      jsonObj = deviceJsonObj(values, isEdit);
    }
    registerOrEditDevice(jsonObj);
  };

  return (
    <Formik
      initialValues={initialFormValues}
      enableReinitialize={enableFormReinitialize}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        if (
          values.deviceId !== "" &&
          values.deviceType !== "" &&
          values.attributeList !== ""
        ) {
          onSubmit(values);
        }
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        values,
        setFieldValue,
        setFieldTouched,
        setTouched,
      }) => (
        <Form className="needs-validation" onSubmit={handleSubmit}>
          <div>
            <ToastContainer position="top-center" />
            {loading && <Loader />}
            <div className="page-content">
              <Container fluid>
                <BreadCrumb title={title} pageTitle={PAGE_TITLES.DEVICE_LIST} moduleTitle="Devices" />
                <Row>
                  <div className=" mb-2">
                    <h5 className="rv-page-title p-1">
                      {isEdit ? "Edit Device" : isView ? "View Device" : "Add Device"}
                    </h5>
                  </div>
                  {isView ? <ViewDevice /> :
                    <Col lg={12}>
                      <div className="border p-4">
                        <div className="live-preview">
                          <Row className="gy-4">
                            <DeviceForm
                              values={values}
                              isEdit={isEdit}
                              errors={errors}
                              touched={touched}
                              setFieldValue={setFieldValue}
                              initialValues={initialValues}
                              DeviceType={DeviceType}
                              StatusType={StatusType}
                              handleChange={handleChange}
                            />
                          </Row>
                        </div>
                        {isEdit ? (
                          <CardBody className="card-body mt-3">
                            <div className="live-preview">
                              <Row className="gy-4">
                                <Col xxl={3} md={6}>
                                  <LabelText
                                    htmlFor="Device Type"
                                    className="text-danger"
                                    displayText="Customer Name"
                                  />
                                  <p className="ms-1"> {fetchDeviceData.customerName ? fetchDeviceData.customerName : '-'}</p>
                                </Col>
                                <Col xxl={3} md={6}>
                                  <LabelText
                                    htmlFor="Device Type"
                                    className="text-danger"
                                    displayText="Customer ID"
                                  />
                                  <p className="ms-1"> {fetchDeviceData.customerId ? fetchDeviceData.customerId : '-'}</p>
                                </Col>
                                <Col xxl={3} md={6}>
                                  <LabelText
                                    htmlFor="Device Type"
                                    className="text-danger"
                                    displayText="Subscription ID"
                                  />
                                  <p className="ms-1"> {fetchDeviceData.subscriptionId ? fetchDeviceData.subscriptionId : '-'}</p>
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                        ) : null}
                        <Attribute
                          values={values}
                          touched={touched}
                          errors={errors}
                          initialValues={initialValues}
                          setTouched={setTouched}
                          handleChange={handleChange}
                          handleChangeForAttributeValue={
                            handleChangeForAttributeValue
                          }
                          isEmptyOrInvalidField={isEmptyOrInvalidField}
                          deviceID={deviceID}
                          isEdit={isEdit}
                        />
                      </div>
                      <Row className="my-4 mb-5">

                        <div className="d-flex justify-content-end gap-2 mt-5">
                          <CommonButton
                            outline={true}
                            className={
                              "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                            }
                            color={"main-color"}
                            type={"reset"}
                            buttonAction={() => navigate('/devices')}
                            buttonText={"Cancel"}
                            icon={
                              <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                            }
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                          />
                          <CommonButton
                            color={"main-color"}
                            className={
                              "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                            }
                            icon={<i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>}
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                            type={"submit"}
                            buttonText={"Submit"}
                          />
                        </div>

                      </Row>
                    </Col>}
                </Row>
              </Container>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
